import { Vue } from 'vue-property-decorator'

export interface ICampoTemplate {
  nome: string
  label: string
  tipoDoCampo: string
  valor: string | number | boolean | string[]
  obrigatorio: boolean
  desabilitado: boolean
  hint?: string
  maxLength?: number
  minLength?: number
  min?: number
  max?: number
  mascara?: string
  opcoes?: Array<{ label: string; value: string | number }>
  cols?: number
  colsMd?: number
  colsSm?: number
  propriedadesAdicionais?: {
    outlined?: boolean
    dense?: boolean
    clearable?: boolean
    [key: string]: any
  }
}

export class BaseInput extends Vue {
  campo: ICampoTemplate

  constructor() {
    super()
    this.campo = {
      nome: '',
      label: '',
      tipoDoCampo: 'text',
      valor: '',
      obrigatorio: false,
      desabilitado: false,
    }
  }

  get propriedadesBase() {
    return {
      v_model: this.campo.valor,
      label: this.campo.label,
      hint: this.campo.hint,
      disabled: this.campo.desabilitado,
      ...this.campo.propriedadesAdicionais,
    }
  }

  get regrasValidacao() {
    const regras: any[] = []

    if (this.campo.obrigatorio) {
      regras.push((v: any) => !!v || `${this.campo.label} é obrigatório`)
    }

    if (this.campo.minLength) {
      const minLength = this.campo.minLength
      regras.push((v: string) => !v || v.length >= minLength || `Mínimo de ${minLength} caracteres`)
    }

    if (this.campo.maxLength) {
      const maxLength = this.campo.maxLength
      regras.push((v: string) => !v || v.length <= maxLength || `Máximo de ${maxLength} caracteres`)
    }

    return regras
  }
}

